<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/managerMoney')">区总奖励查询</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
          >
          <el-form-item label='代理信息'>
            <el-input
              style="width:200px"
              v-model="filters.user"
              placeholder="请输入姓名或者手机号"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form-item>

          
          <el-form-item label='类型'>
            <el-select
              v-model="filters.type"
              clearable
            >
              <el-option
                label="直属奖"
                :value="1"
              ></el-option>

              <el-option
                label="推荐奖"
                :value="2"
              ></el-option>

            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut()"
              type="primary"
              size="small"
            >导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
          总金额：{{data}}
        </div>

        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="userName"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telePhone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            prop="infoMoney"
            label="总金额"
          >
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-count='allPageNumber'
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

  </el-main>
</template>


<script>
// import { bus } from "../../bus.js";
import API from "../../api/api_user";
// import { dateFunc } from "../../dateFunc";
// import { filter } from 'vue/types/umd';
var _ = require("lodash");
export default {
  name: "checkStockList",
  created() {},

  data() {
    return {
      totalMoney: 0,
      listLoading: false,
      picList: [],
      filters: {
        startTime: null,
        type: 1,
        endTime: null,
        user: null,
        dayType: null
      },
      page: 1,
      page_page: 0,
      pageSize: 10,
      total_num: 0,
      total_page: 0,
      data: 0.0,
      tableHeight:null,
      tableData: [],
      count: 0,
      allPageNumber: 0
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page = 1;
    this.handleSearch();
  },
  methods: {
    excelOut() {
      var that = this;
      var url =
        "/manager/user/money/excel?user=";
        if(that.filters.user){
          params.user = that.filters.user
        }
        url= url +"&startTime=" +  that.filters.startTime.getTime();
        url= url +"&endTime=" + that.filters.endTime.getTime();
        url= url +"&type="+ that.filters.type;
       top.location.href = url
    },
    handleSearch() {
      console.log(this.filters)
      this.pageSize = 10;
      this.page = 1;
      this.searchMoney();
      //this.search();
    },
    searchMoney() {
      let that = this;
      let params = {
        page: that.page,
        pageSize: that.pageSize
      };
    if(that.filters.user){
      params.user = that.filters.user
      }
        if(that.filters.type){
          params.type = that.filters.type
        }
      if(that.filters.startTime){
        params.startTime = that.filters.startTime.getTime();
        }else{
          this.$message.error({
            showClose: true,
            message: "请输入开始时间",
            duration: 2000
          });
          return;
        }
        if(that.filters.endTime){
          params.endTime = that.filters.endTime.getTime();
        }else{
          this.$message.error({
            showClose: true,
            message: "请输入结束时间",
            duration: 2000
          });
          return;
        }
      that.listLoading = true;
      API.manager_user_money(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.tableData= result.result.list
              that.count = result.result.count
              that.allPageNumber= result.result.allPageNumber
              that.data= result.result.data
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.searchMoney();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/good/managerMoney.vue